import popupStyles from "../generalSuccessPopup/generalSuccessPopup.module.css";
import doctor from "../../../images/questionnaire_doctor.png";
import { IPopupWithoutProps } from "../../../types/types";
import { tWithKeyAttr as t } from "../../../i18nHelper";
import { openAuthenticatedFile } from "../../../utils/fileDownload";

interface IReportSuccessPopupProps extends IPopupWithoutProps {
  reportUrl: string;
}

function ReportSuccessPopup({ onClose, reportUrl }: IReportSuccessPopupProps) {
  return (
    <article className={popupStyles.popup} data-testid="report-success-popup">
      <h2 className={popupStyles.popup__title}>
        {t("REPORT_GENERATED_SUCCESSFULLY")}
      </h2>
      <img
        src={doctor}
        alt={t("IMAGE_OF_VENUS")}
        className={popupStyles.popup__img}
      />
      <div className={popupStyles.popup__content}>
        <p className={popupStyles.popup__text}>
          {t("REPORT_VIEW_INSTRUCTION")}
        </p>
        <p className={popupStyles.popup__text}>{t("REPORT_FIND_ALL")}</p>
      </div>
      <div className={popupStyles.popup__buttons}>
        <button
          className={`button hover ${popupStyles.popup__nextBtn}`}
          data-testid="view-report-button"
          onClick={() => openAuthenticatedFile(reportUrl).catch((error) => console.error(t("DOWNLOAD_ERROR"), error))}
        >
          {t("VIEW_GENERATED_REPORT")}
        </button>
        {/*<button*/}
        {/*  className={`button hover ${popupStyles.popup__nextBtn}`}*/}
        {/*  data-testid="success-popup-ok-button"*/}
        {/*  onClick={onClose}*/}
        {/*>*/}
        {/*  {t("CONFIRM")}*/}
        {/*</button>*/}
      </div>
    </article>
  );
}

export default ReportSuccessPopup;
